/**
 * 层数的取值规则，各三维视图共用。
 *
 * 同一栋楼里各单元的层数可以不同：建模端标注户型时能单独填一个层数，
 * 存在 residential_building_house.total_floor 上，下发时挂在 houseList 每一项的 totalFloor。
 * 没填（null / 0）就沿用楼栋的 totalFloor。
 */

/** 某个户型（单元）实际要渲染的层数 */
export function getHouseFloors (houseRoom, building) {
  const houseFloors = houseRoom && houseRoom.totalFloor
  return houseFloors > 0 ? houseFloors : (building && building.totalFloor) || 0
}

/**
 * 楼栋实际最高的层数。楼栋标签挂在楼顶上方，各单元不一样高时要按最高的那个挂，
 * 否则楼栋层数填 30、各单元只有 20 时标签会飘在半空。
 */
export function getBuildingMaxFloors (building) {
  if (!building) {
    return 0
  }
  const houseList = building.houseList || []
  return houseList.reduce(
    (max, houseRoom) => Math.max(max, getHouseFloors(houseRoom, building)),
    houseList.length > 0 ? 0 : building.totalFloor || 0
  )
}

/**
 * 2D 表格（采光/噪音/视野/销控）按 unit+room 查某户型的实际层数。
 * unit/room 在各处可能是字符串也可能是数字（表格行列键 vs 后端 VO），统一转字符串/数字比较。
 */
export function getHouseFloorsByUnitRoom (building, unit, room) {
  const houseList = (building && building.houseList) || []
  const houseRoom = houseList.find(h => String(h.unit) === String(unit) && Number(h.room) === Number(room))
  return getHouseFloors(houseRoom, building)
}
